import {
    makeStyles,
} from 'app/tss'

const general = 'general'
const handover = 'handover'
const collection = 'collection'

const useStyles = makeStyles()((theme) => {
    return {
        gridWrapper: {
            display: 'grid',
            gridGap: theme.spacing(2),
            gridTemplateAreas: `
                "${general} ${handover}"
                "${general} ${collection}"
                `,
            gridTemplateColumns: 'repeat(2, 2fr)',
        },
        general: {
            gridArea: general,
        },
        handover: {
            gridArea: handover,
        },
        collection: {
            gridArea: collection,
            height: 'fit-content',
        },
    }
})

export default useStyles
